// Referral system utilities
export interface ReferralData {
  referrerFid: string | null;
  hasReferrer: boolean;
}

// Extract referrer FID from URL parameters
export const extractReferralData = (): ReferralData => {
  const urlParams = new URLSearchParams(window.location.search);
  const referrerFid = urlParams.get('ref');
  
  return {
    referrerFid: referrerFid || null,
    hasReferrer: !!referrerFid
  };
};

// Save referral data to localStorage for later use
export const saveReferralData = (referralData: ReferralData): void => {
  if (referralData.hasReferrer && referralData.referrerFid) {
    localStorage.setItem('referral_data', JSON.stringify(referralData));
  }
};

// Get saved referral data from localStorage
export const getSavedReferralData = (): ReferralData | null => {
  const saved = localStorage.getItem('referral_data');
  if (saved) {
    try {
      return JSON.parse(saved);
    } catch (e) {
      console.error('Error parsing saved referral data:', e);
    }
  }
  return null;
};

// Clear referral data after successful processing
export const clearReferralData = (): void => {
  localStorage.removeItem('referral_data');
};

// Generate referral URL for sharing
export const generateReferralUrl = (userFid: string, cardIds?: string[]): string => {
  const baseUrl = window.location.origin;
  const params = new URLSearchParams();
  
  // Add referrer FID
  params.set('ref', userFid);
  
  // Add cards if provided
  if (cardIds && cardIds.length > 0) {
    params.set('cards', cardIds.join(','));
  }
  
  return `${baseUrl}?${params.toString()}`;
};

// Process referral when user completes their first reading
export const processReferral = async (userFid: string): Promise<boolean> => {
  const referralData = getSavedReferralData();
  
  if (!referralData || !referralData.hasReferrer || !referralData.referrerFid) {
    return false;
  }
  
  try {
    // TODO: Send to Supabase when ready
    console.log('Processing referral:', {
      referrerFid: referralData.referrerFid,
      referredFid: userFid,
      timestamp: new Date().toISOString()
    });
    
    // Clear referral data after processing
    clearReferralData();
    return true;
  } catch (error) {
    console.error('Error processing referral:', error);
    return false;
  }
}; 